import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import TopNav from "./TopNav";
import Routes from "./Routes";
import SetCookiesToStorage from "./SetCookiesToStorage";
import { InterceptorService } from "./interceptor";

// interceptor
InterceptorService();

const NavigatorComponent = () => {
  const navigate = useNavigate();

  const navigateTo = (path) => {
    navigate(path);
  };

  return (
    <>
      <SetCookiesToStorage navigateTo={navigateTo}>
        <TopNav navigateTo={navigateTo} />
        <Routes navigateTo={navigateTo} />
      </SetCookiesToStorage>
    </>
  );
};
export default NavigatorComponent;
